module.exports = __webpack_public_path__ + "fonts/subset-MullerUltraLight.7f70fa8b.woff";